import { BaSeTheme } from '@base/react';
import styled, { css } from 'styled-components';

const handleQuery = (style) => {
  return `
    ${BaSeTheme.breakpoints.mobileLarge.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobile.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobileSmall.mediaQueryCss(style)};
  `;
};

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 30px;
  padding: 8px 0;
  margin: 0px 12px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;

  gap: 30px;
`;

export const Content = styled.div`
  padding: 16px 24px;
  position: relative;
  background: ${BaSeTheme.colors.defaultColors.white};
  border: 1px solid ${BaSeTheme.colors.institucionais.cinzaSebrae90};
  box-shadow: 0px 32px 30px rgba(20, 46, 82, 0.2);
  border-radius: 4px;
  max-width: 650px;
  width: 100%;
  ${handleQuery(`
    width: 90%;
  `)}
`;

export const ContentText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  gap: 16px;
`;

export const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  gap: 8px;
  margin-top: 24px;
`;
export const BoxRadio = styled.div`
  ${({ nome }) =>
    nome === 'PROXIMIDADE'
      ? css`
          display: flex;
          flex-direction: column;
        `
      : css`
          display: grid;
          grid-template-columns: 1fr 1fr 1fr 1fr;
        `}
  gap: 8px;

  ${handleQuery(`
      grid-template-columns: 1fr;
  `)}
`;

export const BoxCheckbox = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  gap: 8px;
  ${handleQuery(`
      grid-template-columns: 1fr;
  `)}
`;

export const AlignButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  gap: 8px;
`;
